import * as React from "react";
import * as moment from "moment";
import Divider from 'material-ui/Divider';
import FlatButton from 'material-ui/FlatButton';
import Dialog from 'material-ui/Dialog';
import { FormGroup, FormControl } from "react-bootstrap";
import { GlosaEmpleador } from "../modelo/GlosaEmpleador";
import { obtenerProcesoGestion } from "../modelo/TiposProcesosGestion";
import DatePicker from "react-datepicker";
import classNames from "classnames";

export class ModalGestionGlosas extends React.Component<ModalGestionGlosasProps, any> {

    constructor(props: any) {
        super(props);

        this.state = {
            show: true,
            observacion: '',
            fechaIngreso: moment(new Date(), DatePicker.DATE_FORMAT)
        };
    }

    handleShow() {
        this.setState({ show: true });
    }

    handleClose() {
        this.setState({ show: false });
        this.props.cerrarModal();
    }

    render() {
        return (
            <div>
                {this.renderModalGestion()}
            </div>
        );
    }

    renderModalGestion() {
        const { codigoProceso } = this.props;
        const btnAcciones = [
            (
                <FlatButton key={1}
                    label={obtenerProcesoGestion(codigoProceso).nombreProceso}
                    disabled={!this.state.observacion && this.noEsProcesoJerarquia(codigoProceso)}
                    onClick={() => {
                        if (codigoProceso === 6) {
                            this.handleClose();
                            this.props.procesarJerarquia();
                        }
                        else if (this.state.observacion.length > 0) {
                            this.handleClose();
                            this.props.gestionarGlosas(codigoProceso, this.state.observacion, this.state.fechaIngreso);
                        }
                    }} />
            ), (
                <FlatButton key={0}
                    label="Cerrar"
                    onClick={() => this.handleClose()} />
            )
        ];
        return (
            <div>
                <Dialog title={"Gestión de Glosas SAT"}
                    actions={btnAcciones}
                    contentStyle={{ width: '40%', maxWidth: 'none' }}
                    open={this.state.show}
                    onRequestClose={() => this.handleClose()}
                    modal={false}>
                    {this.renderContenidoGestion()}
                </Dialog>
            </div>
        );
    }

    renderContenidoGestion() {
        const { codigoProceso } = this.props;
        return (
            <div>
                <div className="modal-form-text">
                    <label><b>Observación para {obtenerProcesoGestion(codigoProceso).nombreProceso.toLocaleLowerCase()} glosas</b></label>
                    <Divider />
                    <br />
                </div>
                <div>
                    <div className="modal-form-text info-col" style={{ marginBottom: '25px' }}>
                        {
                            this.props.estadoMasivoActivo() ?
                                <span>
                                    <strong>Gestión Masiva Activa:</strong> La gestión se hará de forma asíncrona, por lo que no recibirás
                                    respuesta inmediata.
                                </span>
                                :
                                <span>
                                    <strong>Gestión Masiva Desactivada:</strong> La gestión se hará de forma síncrona, por lo que tendrás que
                                    esperar la respuesta del sistema para poder seguir operando en la aplicación.
                                </span>
                        }
                    </div>
                    <FormGroup controlId="formControlsTextarea">
                        {
                            this.esReprocesoAfiliacionTraslado(codigoProceso) &&
                            <div className="modal-form-text info-col">
                                <div>
                                    <span>
                                        <strong>Fecha Envio Formulario: </strong> Con esta fecha se enviará la información a SAT. Esta corresponde a la fecha de carta.
                                    </span>
                                </div>
                                <br />
                                <div>
                                    <div className={"input-group date"}>
                                        <DatePicker
                                            autoComplete="off"
                                            className={classNames("form-control", "CustomClass")}
                                            selected={this.state.fechaIngreso}
                                            onChange={(date) =>
                                                this.setState({ fechaIngreso: date })
                                            }
                                        />
                                        <span className="input-group-addon cursor-auto"> <i
                                            className="glyphicon glyphicon-time" /> </span>
                                    </div>
                                </div>
                            </div>
                        }
                    </FormGroup>
                    <FormGroup controlId="formControlsTextarea" validationState={this.getValidationState()}>
                        {    this.noEsProcesoJerarquia(codigoProceso) &&
                            <FormControl
                                value={this.state.observacion}
                                onChange={e => this.setState({ observacion: e.target.value })}
                                componentClass="textarea"
                                placeholder="Observación"
                                style={{ height: 130 }} maxLength={256}
                            />
                        }
                    </FormGroup>
                </div>
            </div>
        );
    }

    getValidationState() {
        const length = this.state.observacion.length;
        if (length > 0) return 'success';
        if (length === 0) return 'error';
        return null;
    }

    esReprocesoAfiliacionTraslado(codigoProceso: number) {
        return codigoProceso === 5;
    }

    noEsProcesoJerarquia(codigoProceso: number) {
        return codigoProceso !== 6;
    }

}

interface ModalGestionGlosasProps {
    listaSeleccionGlosas: Array<GlosaEmpleador>,
    codigoProceso: number,
    cerrarModal: () => void,
    gestionarGlosas: (codigoProceso: number, observacion: string, fechaIngreso: any) => void,
    estadoMasivoActivo?: () => boolean,
    procesarJerarquia: () => void
}


// WEBPACK FOOTER //
// ./src/co/sura/dominio/sat/inconsistencias/componentes/ModalGestionGlosas.tsx